'use client';

import {
  AnalyticsSkuViewed,
  type AnalyticsSkuViewedProps,
} from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import { useCardPosition } from 'src/features/roundup-filters/CardPositionContext';
import { useFiltersDialogContext } from 'src/features/roundup-filters/Mobile/components/FiltersDialogContext';
import {
  type ExperimentOfferData,
  ExperimentOfferProvider,
} from 'src/shared/providers/ExperimentOfferContext';

export function ProductCardAnalyticsWrapper({
  children,
  skuViewedProps,
  experimentOfferData,
  wrapperProps,
}: {
  children: React.ReactNode;
  skuViewedProps: AnalyticsSkuViewedProps;
  experimentOfferData?: ExperimentOfferData;
  wrapperProps: React.ComponentProps<'div'> & Record<`data-${string}`, string>;
}) {
  const { isMobileFiltersDialogOpen } = useFiltersDialogContext();
  const impressionPosition = useCardPosition(skuViewedProps.impressionPosition);
  return (
    <ExperimentOfferProvider value={experimentOfferData ?? null}>
      <AnalyticsSkuViewed
        enabled={!isMobileFiltersDialogOpen}
        {...skuViewedProps}
        impressionPosition={impressionPosition}
      >
        <div {...wrapperProps}>{children}</div>
      </AnalyticsSkuViewed>
    </ExperimentOfferProvider>
  );
}
